import { z } from 'zod';

export const PushNotificationDataInputSchema = z.object({
  url: z.string().url().optional().nullable(),
});

export const PushNotificationContentInputSchema = z.object({
  body: z.string().min(1, 'Push notification body is required'),
  title: z.string().min(1, 'Push notification title is required'),
});

export const PushNotificationTemplateInputSchema = z.object({
  data: PushNotificationDataInputSchema.optional().nullable(),
  notification: PushNotificationContentInputSchema,
});

export const TestMessageTemplateInputSchema = z
  .object({
    smsBody: z.string().optional().nullable(),
    pushNotificationTemplate: PushNotificationTemplateInputSchema.optional().nullable(),
  })
  .refine(
    ({ smsBody, pushNotificationTemplate }) => {
      return !!smsBody || !!pushNotificationTemplate;
    },
    { message: 'At least one of SMS Body or Push Notification Content must be defined' },
  );

export const SendTestMessageInputSchema = z.object({
  membershipId: z.string().uuid('Membership ID is required'),
  messageTemplate: TestMessageTemplateInputSchema,
});
